import axios from './configAxiosOrganizations';

export const getOrgContract = async (org_id, contract_id) => {
	return await axios.get(`/${org_id}/contract/${contract_id}/file/`);
};
